<div class="card">
  <strong>{{title}}</strong>
    <p class="confirm">{{text}}</p>
    <p *ngIf="linkText"><a href="{{linkHref}}">{{linkText}}</a></p>
</div>
